import render from './render'

export default {
  name: 'Header',

  props: {
    options: {
      type: Object,
      default: () => {
        return {}
      }
    },

    label: String
  },

  computed: {
    as() {
      if (this.viewport.size.width > 1920) {
        return 'select'
      }
    }
  },

  render
}
